import "./ErrorPage.css";

const ErrorPage = () => {
  return (
    <div className="error-container">
      <h1 className="error-title">契約期間が終了しています</h1>
      <p className="error-message">
        このプランはご契約いただけません。
      </p>

    </div>
  );
};

export default ErrorPage;
